
  export enum AclTipo {
    DGPE = 'dgpe',
    DPCPL = 'dpcpl',
    EELL = 'eell',
    MULTI = 'multi',
    EDEL = 'edel'
  }
